import { z } from 'zod'
import { Model } from '../../_kernel/architecture'
import { Tax } from './Tax'
import type { ListOfAvailabilityReduxLegacyType } from './ListOfAvailabilityReduxLegacySchema'
import type { Currencies } from '../../_kernel/Currency'

export const ListOfTaxValidation = z.object({
  list: z.instanceof(Tax, { message: '[ListOfTax] list is required' }).array(),
})

export class ListOfTax extends Model {
  static create({ list }: z.infer<typeof ListOfTaxValidation>) {
    ListOfTaxValidation.parse({ list })
    return new ListOfTax(list)
  }

  static fromJSON({ json }: { json: ReturnType<ListOfTax['toJSON']> }) {
    return ListOfTax.create({
      list: json.list.map(tax => Tax.fromJSON(tax)),
    })
  }

  static fromAvailabilityBoardRedux({ board }: { board: ListOfAvailabilityReduxLegacyType }) {
    return ListOfTax.create({
      list: board.taxDetails.map(tax =>
        Tax.fromJSON({
          amount: tax.amount,
          currency: tax.currency as Currencies,
          included: tax.included,
          name: tax.name,
          client: tax.client
            ? { amount: tax.client.amount, currency: tax.client.currency as Currencies }
            : undefined,
          local: tax.local
            ? { amount: tax.local.amount, currency: tax.local.currency as Currencies }
            : undefined,
        })
      ),
    })
  }

  constructor(readonly list: Tax[]) {
    super()
  }

  toJSON() {
    return { list: this.list.map(item => item.toJSON()) }
  }

  map<T>(callback: (Tax: Tax, index: number) => T) {
    return this.list.map(callback)
  }
}
